<div class="login-wrapper">
    <div class="row">
        <div class="col-md-6 offset-md-3">
            <form class="auth-form" name="loginForm" #f="ngForm" (ngSubmit)="f.form.valid ? login(f) : null">
                <h4>Use your account to log in.</h4>
                <hr />
                <div class="text-danger validation-summary-errors" *ngIf="(f.submitted && !f.valid) || loginError">
                    <ul>
                        <li *ngIf="loginError">Invalid login attempt.</li>
                        <li *ngIf="!username.valid">Username is required.</li>
                        <li *ngIf="!password.valid">Password is required.</li>
                    </ul>
                </div>
                <div class="form-group">
                    <label for="userName">Username</label>
                    <input
                        class="form-control"
                        autofocus=""
                        type="text"
                        id="userName"
                        name="userName"
                        [(ngModel)]="userLogin.userName"
                        #username="ngModel"
                        required
                        [ngClass]="{ 'input-validation-error': (f.submitted && !username.valid) || loginError }"
                    />
                    <span class="text-danger field-validation-error" *ngIf="f.submitted && !username.valid">Username is required.</span>
                </div>
                <div class="form-group">
                    <label for="Password"> Password </label>
                    <input
                        class="form-control"
                        type="password"
                        id="password"
                        name="password"
                        [(ngModel)]="userLogin.password"
                        #password="ngModel"
                        required
                        [ngClass]="{ 'input-validation-error': (f.submitted && !password.valid) || loginError }"
                    />
                    <span class="text-danger field-validation-error" *ngIf="f.submitted && !password.valid">Password is required.</span>
                </div>
                <div class="form-group custom-control custom-checkbox">
                    <input
                        class="custom-control-input"
                        type="checkbox"
                        id="rememberMe"
                        name="rememberMe"
                        [(ngModel)]="userLogin.rememberMe"
                    />
                    <label class="custom-control-label" for="rememberMe">Remember me</label>
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="isLoading">Log in</button>
            </form>
        </div>
    </div>
</div>
